module.exports = __webpack_public_path__ + "static/img/struct2.b94077c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/struct2.png
// module id = JDf+
// module chunks = 1